module.exports = __webpack_public_path__ + "static/media/CT_2019_30452_pdf.8ba52676.pdf";